<!-- 
Listing of exception log entries.
-->
<template>
  <div>
    <v-card class="home">
      <our-table-header 
        :listing="listing"
        :search-filters="searchFilters"
        :criteria-mutation="criteriaMutation"
        :has-export="hasExport"
        @click:refresh="refresh" 
        @click:export="exportToExcel"
        @update:pageNumber="updatePageNumber" 
        @update:criteria="refresh"
      />
      <our-table-busy-indicator :show="listing.loading"/>
      <v-data-table 
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging" 
        :total-items="listing.paging.totalItems" 
        :rows-per-page-items="rowsPerPageItems" 
        :no-data-text="noDataText"
        must-sort 
        hide-actions
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr @click.stop="rowSelected(props.item.id, props.item)">
            <our-nav-col :row="props.item.name"/>
            <td>{{ props.item.id }}</td>
            <td :class="props.item.level | exceptionLogColour">
              {{ props.item.level }}
            </td>
            <td>{{ props.item.date | compactDateTime }}</td>
            <td>{{ props.item.message }}</td>
            <td>{{ props.item.userName }}</td>
            <td class="text-xs-center px-2">
              <v-tooltip bottom>
                <v-btn 
                  slot="activator"
                  :to="`/exception-logs/${props.item.id}`" icon small target="_blank" 
                  class="ma-0 " @click.stop
                >
                  <v-icon small>open_in_new</v-icon>
                </v-btn>
                <span>Open this record in a new tab</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
      <our-table-footer :paging="listing.paging" @update:pageNumber="updatePageNumber" @update:rowsPerPage="updateRowsPerPage" />
    </v-card>
  </div>
</template>

<script>
import * as action from "@/store/exception-logs/action-types";
import * as mutation from "@/store/exception-logs/mutation-types";
import tableMixins from "@/mixins/table.mixins";
import filterMixins from "@/mixins/filter.mixins";
import { getSearchFilters } from "@/store/exception-logs/helpers";
import { EXCEPTION_LOGS_EXPORT } from "@/store/claim-types";

export default {
  mixins: [tableMixins, filterMixins],
  data() {
    return {
      action: action.LIST,
      exportAction: action.EXPORT,
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      pagingMutation: mutation.LIST_SET_PAGING
    };
  },
  computed: {
    headers() {
      return [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "ID", value: "Id", sortable: this.canSort, width: 50 },
        { text: "Level", value: "Level", sortable: this.canSort, width: 50 },
        { text: "Date", value: "Date", sortable: this.canSort, width: 200 },
        { text: "Message", value: "Message", sortable: false },
        { text: "User", value: "UserName", sortable: this.canSort },
        { text: "Actions", value: "Id", sortable: false, align: "right", width: 100 }
      ];
    },
    listing() {
      return this.$store.state.exceptionLogs.listing;
    },
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.listing.criteria;
    },
    loaded() {
      return this.listing.loaded;
    },
    hasExport() {
      return this.$store.getters.claims.includes(EXCEPTION_LOGS_EXPORT);
    }
  },
  watch: {
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      if (!this.listing.loaded && !this.listing.loading) {
        this.populate();
      }
    }
  }
};
</script>
